module.exports = __webpack_public_path__ + "assets/9729a00a226ed65cab96b1f42572bdc9.png";